import { z } from 'zod'
import { IntervalBasis } from '../enums'
import { Id, Timestamp } from './common'

export const DueStatusSchema = z.enum(['ok', 'due_soon', 'overdue'])

export const ServiceInterval = z.object({
  id: Id,
  component_id: Id.nullable(),
  bike_id: Id.nullable(),
  /** The bike it currently applies to (a part's current bike, or the bike itself). */
  current_bike_id: Id.nullable(),
  current_bike_name: z.string().nullable(),
  component_name: z.string().nullable(),
  label: z.string(),
  basis: IntervalBasis,
  /** SI: metres, seconds or days. */
  threshold: z.number(),
  last_reset_at: Timestamp,
  status: DueStatusSchema,
  fraction: z.number(),
  used: z.number(),
  remaining: z.number(),
})
export type ServiceInterval = z.infer<typeof ServiceInterval>

export const ServiceIntervalList = z.object({ intervals: z.array(ServiceInterval) })
export type ServiceIntervalList = z.infer<typeof ServiceIntervalList>

export const CreateIntervalBody = z
  .object({
    component_id: Id.nullable().optional(),
    bike_id: Id.nullable().optional(),
    label: z.string().trim().min(1, 'Say what the service is.').max(120),
    basis: IntervalBasis,
    threshold: z.number().positive(),
    /** When the part was last serviced. Defaults to now. */
    last_reset_at: Timestamp.optional(),
  })
  .refine(
    (b) => !!b.component_id !== !!b.bike_id,
    'Attach the interval to a part or a bike, not both.',
  )
export type CreateIntervalBody = z.input<typeof CreateIntervalBody>

export const UpdateIntervalBody = z
  .object({
    label: z.string().trim().min(1).max(120),
    basis: IntervalBasis,
    threshold: z.number().positive(),
    last_reset_at: Timestamp,
  })
  .partial()
  .refine((b) => Object.keys(b).length > 0, 'Nothing to update.')
export type UpdateIntervalBody = z.input<typeof UpdateIntervalBody>

export const ResetIntervalBody = z.object({ at: Timestamp.optional() })

export const IntervalListQuery = z.object({
  bike_id: Id.optional(),
  component_id: Id.optional(),
  status: z.enum(['due', 'all']).default('all'),
})
